/**
 * Copy comercial UX para planes 0E3 POS (solo presentación — no afecta billing ni módulos).
 * Labels/cupos desde SSOT vía planTiers (POS-PLANS-SSOT-001B-CLOSURE-001).
 */

import { PLAN_LABELS_ES, PLAN_COMMERCIAL_META } from './planTiers';

const u = (tier) => PLAN_COMMERCIAL_META[tier].includedUsers;
const b = (tier) => PLAN_COMMERCIAL_META[tier].includedBranches;

export const PLAN_COMMERCIAL_UX_ES = {
  basic: {
    title: PLAN_LABELS_ES.basic,
    subtitle: 'Ideal para kioscos, despensas y pequeños comercios.',
    intro: 'Con START podés:',
    benefits: [
      'Cobrar rápido desde celular, tablet o PC.',
      'Controlar ventas diarias.',
      'Manejar stock de productos.',
      'Registrar compras y gastos.',
      'Administrar cuentas corrientes.',
      `Trabajar con hasta ${u('basic')} usuarios.`,
      `Administrar ${b('basic')} sucursal.`
    ],
    highlight: 'Perfecto para negocios que están comenzando o tienen pocos empleados.'
  },
  intermediate: {
    title: PLAN_LABELS_ES.intermediate,
    subtitle: 'Ideal para minimercados, autoservicios y distribuidoras pequeñas.',
    intro: 'Con PRO podés:',
    benefits: [
      'Todo lo incluido en START.',
      'Controlar varias sucursales.',
      'Transferir mercadería entre locales.',
      'Auditar movimientos.',
      'Tener reportes más avanzados.',
      `Trabajar con hasta ${u('intermediate')} usuarios.`,
      `Administrar hasta ${b('intermediate')} sucursales.`
    ],
    highlight: 'Pensado para negocios en crecimiento.'
  },
  premium: {
    title: PLAN_LABELS_ES.premium,
    subtitle: 'Ideal para supermercados, fábricas, panaderías y negocios con producción propia.',
    intro: 'Con EMPRESA podés:',
    benefits: [
      'Todo lo incluido en PRO.',
      'Crear recetas.',
      'Gestionar materias primas.',
      'Controlar producción.',
      'Analizar tu negocio con indicadores avanzados.',
      `Trabajar con hasta ${u('premium')} usuarios.`,
      `Administrar hasta ${b('premium')} sucursales.`
    ],
    highlight: 'Pensado para operaciones complejas y equipos grandes.'
  }
};

/** Filas de tabla comparativa — valores: true | false | string */
export const PLAN_COMPARISON_ROWS = [
  {
    label: 'Usuarios',
    basic: String(u('basic')),
    intermediate: String(u('intermediate')),
    premium: String(u('premium'))
  },
  {
    label: 'Sucursales',
    basic: String(b('basic')),
    intermediate: String(b('intermediate')),
    premium: String(b('premium'))
  },
  { label: 'Ventas', basic: true, intermediate: true, premium: true },
  { label: 'Caja', basic: true, intermediate: true, premium: true },
  { label: 'Compras', basic: true, intermediate: true, premium: true },
  { label: 'Clientes', basic: true, intermediate: true, premium: true },
  { label: 'Cuenta corriente', basic: true, intermediate: true, premium: true },
  { label: 'Transferencias', basic: false, intermediate: true, premium: true },
  { label: 'Auditoría', basic: false, intermediate: true, premium: true },
  { label: 'Producción', basic: false, intermediate: false, premium: true },
  { label: 'Recetas', basic: false, intermediate: false, premium: true },
  { label: 'Materias primas', basic: false, intermediate: false, premium: true },
  { label: 'Dashboard ejecutivo', basic: false, intermediate: true, premium: true }
];

export const LOGIN_PLAN_TEASER = [
  { id: 'basic', label: PLAN_LABELS_ES.basic, users: `Hasta ${u('basic')} usuarios` },
  { id: 'intermediate', label: PLAN_LABELS_ES.intermediate, users: `Hasta ${u('intermediate')} usuarios` },
  { id: 'premium', label: PLAN_LABELS_ES.premium, users: `Hasta ${u('premium')} usuarios` }
];

export const LOGIN_PLAN_FEATURES = [
  { label: 'Ventas', plans: ['basic', 'intermediate', 'premium'] },
  { label: 'Caja', plans: ['basic', 'intermediate', 'premium'] },
  { label: 'Compras', plans: ['basic', 'intermediate', 'premium'] },
  { label: 'Cuenta corriente', plans: ['basic', 'intermediate', 'premium'] },
  { label: 'Producción', plans: ['premium'] }
];
